import { DataTableExRef, TablePageLayout } from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React, { useRef } from 'react';

import { CompaniesTable } from 'components/CompaniesTable';
import { HideStationSelector } from 'layouts/HideStationSelector';

export function Companies() {
  const tableRef = useRef<DataTableExRef>(null);

  return (
    <HideStationSelector>
      <TablePageLayout
        title="Bedrijven"
        actionContent={
          <Button
            sx={{ ml: 5 }}
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              tableRef.current?.openFormDialog();
            }}
          >
            Bedrijf toevoegen
          </Button>
        }
      >
        <CompaniesTable
          id="companies-table"
          ref={tableRef}
          searchFilter={{
            inputProps: {
              placeholder: 'Zoeken op naam of E-mail',
            },
            filter: (search) => ({
              _or: search.flatMap((str) => [
                { name: { _ilike: `%${str}%` } },
                // { email: { _ilike: `%${str}%` } },
              ]),
            }),
          }}
          formDialogProps={{
            formProps: {
              defaultValues: {},
            },
          }}
        />
      </TablePageLayout>
    </HideStationSelector>
  );
}
